import React from 'react';
import css from './BlogCard.module.css';
import blog1 from '../../../assets/blog-1.png';
import blog2 from '../../../assets/blog-2.png';
import blog3 from '../../../assets/blog-3.png';
import { AspectRatioWrapper, NamedLink, ResponsiveImage } from '../../../components';
import { ensureOwnListing } from '../../../util/data';
import { createSlug } from '../../../util/urlHelpers';
import { useConfiguration } from '../../../context/configurationContext';
import { tagsList, ARABIC, ENGLISH } from '../../../util/constants';
import { useIntl } from 'react-intl';

const blogData = [
    {
        blogImage: blog1,
        professionalProfile: "ARABIC TUTOR",
        blogTitle: "1 The Joy of Learning Arabic: More Than Just Words",
        blogDescription: "Arabic opens doors to new cultures, stories, and connections. Discover how small daily lessons..."
    },
    {
        blogImage: blog2,
        professionalProfile: "MSA vs. Dialects",
        blogTitle: "MSA vs. Dialects — Which Should You Learn First?",
        blogDescription: "Modern Standard Arabic builds your foundation, while dialects bring real conversations to life..."
    },
    {
        blogImage: blog3,
        professionalProfile: "LEARNING",
        blogTitle: "5 Easy Ways to Stay Motivated When Learning a New Language",
        blogDescription: "Consistency is key! Simple habits, fun lessons, and small rewards can make your learning ..."
    },
]

const BlogCard = (props) => {
    const config = useConfiguration();
    const { listing, renderSizes, } = props;
const intl =useIntl();
    const currentListing = listing;
    const id = currentListing?.id.uuid;
    if (!id) {
        return null;
    }
    const { title = '', description, publicData } = listing?.attributes || {};
    const slug = createSlug(title);
    const language=(intl.locale.toLowerCase().startsWith('ar')) ? 'ar' : 'en';
    const { tags = [], } = publicData || {}
    const tagLabelMap = new Map(
        tagsList.map(tag => [
            tag.key,
            language === ARABIC ? tag.label_ar : tag.label_en
        ])
    );
    const firstImage =
        currentListing?.images && currentListing?.images.length > 0 ? currentListing?.images[0] : null;
    const {
        aspectWidth = 1,
        aspectHeight = 1,
        variantPrefix = 'listing-card',
    } = config.layout.listingImage;
    const variants = firstImage
        ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
        : [];

    return (
        <div className={css.blogCard}>
            <NamedLink name="BlogArticlePage"
                params={{
                    slug: slug || 'untitled', // Ensure slug is never undefined
                    id: id
                }} className={css.blogCardData}>
                <div className={css.blogImage}>
                    {/* <img src={item.blogImage} alt="" /> */}
                    <AspectRatioWrapper width={aspectWidth} height={aspectHeight}>
                        <ResponsiveImage
                            rootClassName={css.rootForImage}
                            alt={title}
                            image={firstImage}
                            variants={variants}
                            sizes={renderSizes}
                        />
                    </AspectRatioWrapper>
                </div>
                <div className={css.blogBody}>
                    <div className={css.professionalProfile}>
                        {tags?.map(tagKey => tagLabelMap.get(tagKey) || tagKey).join(', ')}
                    </div>
                    <div className={css.blogTitle}>{title}</div>
                    <div className={css.blogDescription}>{description}</div>
                </div>
            </NamedLink>
        </div>
    )
}

export default BlogCard